import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { EventType, EventTypeLabels } from 'app/console-api/statistics/types';
import Select from 'react-select';

export const EventTypeFilterAdapter: FilterAdapter<string[]> = {
  key: 'eventTypes',
  fromUrl: (sp) => {
    const raw = sp.get('eventTypes');
    if (!raw) return null;
    const arr = raw
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    return arr.length ? arr : null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value || value.length === 0) {
      next.delete('eventTypes');
    } else {
      next.set('eventTypes', value.join(','));
    }
    return next;
  },
  toKey: (v) => `eventTypes:${v && v.length ? [...v].sort().join(',') : 'all'}`
};

export const EventTypeFilter = (props: any) => {
  const ctl = useUrlFilterController();
  const value = ctl.get(EventTypeFilterAdapter) ?? [];
  const options = Object.values(EventType).map((one) => ({
    label: EventTypeLabels[one],
    value: one
  }));
  const selected = options.filter((o) => value.includes(o.value));
  return (
    <Select
      {...props}
      isMulti
      options={options}
      value={selected}
      hideSelectedOptions={false}
      placeholder={'All Events'}
      onChange={(opts: any) => {
        const selectedEventTypes = opts ? opts.map((o: any) => o.value) : [];
        ctl.set(EventTypeFilterAdapter, selectedEventTypes.length ? selectedEventTypes : null);
      }}
    />
  );
};
